const ucFirst = s => s.substr(0, 1).toUpperCase() + s.substr(1).toLowerCase();
export default ucFirst;

